//PROJECT LIST
export const USER_PROJECT_LIST_REQUEST = 'USER_PROJECT_LIST_REQUEST';
export const USER_PROJECT_LIST_SUCCESS = 'USER_TODO_COMPLETED_LIST_SUCCESS';
export const USER_PROJECT_LIST_FAIL = 'USER_PROJECT_LIST_FAIL';

//PROJECT TIME LIST
export const USER_PROJECT_TIME_LIST_REQUEST = 'USER_PROJECT_TIME_LIST_REQUEST';
export const USER_PROJECT_TIME_LIST_SUCCESS =
  'USER_PROJECT_TIME_LIST_SUCCESS';
export const USER_PROJECT_TIME_LIST_FAIL = 'USER_PROJECT_TIME_LIST_FAIL';

//USER_ADD_WEB_PROJECT_LIST
export const USER_ADD_WEB_PROJECT_LIST_REQUEST = 'USER_ADD_WEB_PROJECT_LIST_REQUEST';
export const USER_ADD_WEB_PROJECT_LIST_SUCCESS =
  'USER_ADD_WEB_PROJECT_LIST_SUCCESS';
export const USER_ADD_WEB_PROJECT_LIST_FAIL = 'USER_ADD_WEB_PROJECT_LIST_FAIL';

//PROJECT_ADD_TIME_IN_LIST
export const USER_PROJECT_ADD_TIME_IN_LIST_REQUEST = 'USER_PROJECT_ADD_TIME_IN_LIST_REQUEST';
export const USER_PROJECT_ADD_TIME_IN_LIST_SUCCESS =
  'USER_PROJECT_ADD_TIME_IN_LIST_SUCCESS';
export const USER_PROJECT_ADD_TIME_IN_LIST_FAIL = 'USER_PROJECT_ADD_TIME_IN_LIST_FAIL';

//PROJECT_DELETE_TIME_IN_LIST
export const USER_PROJECT_DELETE_TIME_IN_LIST_REQUEST = 'USER_PROJECT_DELETE_TIME_IN_LIST_REQUEST';
export const USER_PROJECT_DELETE_TIME_IN_LIST_SUCCESS =
  'USER_PROJECT_DELETE_TIME_IN_LIST_SUCCESS';
export const USER_PROJECT_DELETE_TIME_IN_LIST_FAIL = 'USER_PROJECT_DELETE_TIME_IN_LIST_FAIL';

//PROJECT_DELETE_IN_LIST
export const USER_PROJECT_DELETE_IN_LIST_REQUEST = 'USER_PROJECT_DELETE_IN_LIST_REQUEST';
export const USER_PROJECT_DELETE_IN_LIST_SUCCESS =
  'USER_PROJECT_DELETE_IN_LIST_SUCCESS';
export const USER_PROJECT_DELETE_IN_LIST_FAIL = 'USER_PROJECT_DELETE_IN_LIST_FAIL';

//PROJECT_ADD_TIME_IN_LIST
export const USER_PROJECT_EDIT_TIME_IN_LIST_REQUEST = 'USER_PROJECT_EDIT_TIME_IN_LIST_REQUEST';
export const USER_PROJECT_EDIT_TIME_IN_LIST_SUCCESS =
  'USER_PROJECT_EDIT_TIME_IN_LIST_SUCCESS';
export const USER_PROJECT_EDIT_TIME_IN_LIST_FAIL = 'USER_PROJECT_EDIT_TIME_IN_LIST_FAIL';

//ALL_REPORT_DATA
export const USER_ALL_REPORT_DATA_LIST_REQUEST = 'USER_ALL_REPORT_DATA_LIST_REQUEST';
export const USER_ALL_REPORT_DATA_LIST_SUCCESS =
  'USER_ALL_REPORT_DATA_LIST_SUCCESS';
export const USER_ALL_REPORT_DATA_LIST_FAIL = 'USER_ALL_REPORT_DATA_LIST_FAIL';

//ALL_USER_CHECKIN_LIST
export const USER_ALL_USER_CHECKIN_LIST_REQUEST = 'USER_ALL_USER_CHECKIN_LIST_REQUEST';
export const USER_ALL_USER_CHECKIN_LIST_SUCCESS =
  'USER_ALL_USER_CHECKIN_LIST_SUCCESS';
export const USER_ALL_USER_CHECKIN_LIST_FAIL = 'USER_ALL_USER_CHECKIN_LIST_FAIL';